import Compats from './compats-highlight-wrapper';

export default Compats;
